import { useSetRecoilState } from "recoil";
import styled from "styled-components";

import { TextSm } from "components/atoms/text";
import Modal from "components/organisms/Modal";
import ModalMy from "components/layouts/Header/ModalMy";

import authAtom from "stores/auth";

interface Props {
  name?: string;
}

const Info = ({ name }: Props) => {
  const setAuth = useSetRecoilState(authAtom);

  const handleLogout = () => {
    localStorage.removeItem("TOKEN");
    setAuth({ isLogin: false, type: "" });
    window.location.href = "/login";
  };

  return (
    <div className="flex items-center">
      <Modal
        activator={(onOpen) => (
          <TextSm onClick={onOpen} className="text-white cursor-pointer" bold>
            {name} 님
          </TextSm>
        )}
        modal={(onClose) => <ModalMy onClose={onClose} />}
      />
      <Line />
      <button onClick={handleLogout}>
        <TextSm className="text-white" bold>
          로그아웃
        </TextSm>
      </button>
    </div>
  );
};

const Line = styled.span`
  display: block;
  margin: 0 12px;
  width: 1px;
  height: 12px;
  background: #fff;
`;

export default Info;
